// extracted by mini-css-extract-plugin
export var SPIN = "Icon-module--SPIN--80b64";
export var icon = "Icon-module--icon--9836e";
export var spin = "Icon-module--spin--d6b76";
export var stroke = "Icon-module--stroke--56116";